<template>
    <div>
        <b-modal id="" ref="delete-cate" centered hide-footer hide-header modal-class="del-asset" content-class="modal-width">
            <div class="delete-cate text-center">
                <img src="@/assets/admin/icon/warning.png" alt="">
                <h5>Xóa danh mục</h5>
                <p>Bạn đang yêu cầu xóa bỏ danh mục <br/>
                    Sau khi xác nhận xóa bỏ sẽ không thể hoàn tác
                </p>
                <b-button class="mt-3 mr-3 btn-cancel" @click="hideModal()" block>Hủy bỏ</b-button>
                <b-button class="mt-3" block @click="deleteCate">Xác nhận</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: ''
        }
    },
    computed: {

    },
    methods: {
        show(id) {
            this.id = id
            this.$refs['delete-cate'].show()
        },
        hideModal() {
            this.$refs['delete-cate'].hide()
        },
        emitModalVisible(isClose = false) {
            this.$emit("handleCloseModal", isClose);
        },
        async deleteCate() {
            const storedData = localStorage.getItem('admInfo')
            if (storedData) {
                var info = JSON.parse(storedData)
            }
            const data = {
                "category_id": this.id
            }
            await this.$axios.put('/category/deleteCategory', data, {
                headers: {
                    'x-access-token': info.accessToken,
                } 
            }).then(res => {
                this.$toast.success('Xóa danh mục thành công!')
                this.$refs['delete-cate'].hide()
                this.emitModalVisible(false)
            }).catch(err => {
                this.$toast.error('Xóa danh mục không thành công!')
            })
        }
    }
}
</script>

<style>
    .del-asset .modal-width {
        width: 380px;
    }
</style>
<style lang="css" scoped>

    .delete-cate h5,
    .delete-cate p {
        color: #444444;
    }
    .delete-cate button {
        background-color: #EE3439;
        color: #ffffff;
        font-weight: 500;
        border-radius: 10px;
        border: none;
        min-width: 163px;
        min-height: 42px;
    }

    .delete-cate button:active,
    .delete-cate button:focus {
        background-color: #EE3439 !important;
    }

    .delete-cate button:hover {
        background-color: #EE3439;
    }

    .delete-cate .btn-cancel {
        color: #EE3439;
        border: 1px solid #EE3439;
        background: #ffffff;
    }

    .delete-cate .btn-cancel:hover,
    .delete-cate .btn-cancel:focus,
    .delete-cate .btn-cancel:active {
        background: #ffffff !important;
        color: #EE3439;
        border: 1px solid #EE3439;
    }
    @media (max-width: 375px) {
        .delete-cate .btn-cancel {
            margin-right: 0 !important;
        }

        .delete-cate p {
            font-size: 15px;
        }
    }
</style>